<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="assets/images/check-right.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-primary">Reset Password</h5>
                <p>Your password has been reset successfully</p>
                <button *ngIf="isFirstLogin" matButton="filled" type="button" class="dialog-btn-primary mt-4"
                    (click)="goToDashboard()">Go To Dashboard</button>
                    <button *ngIf="!isFirstLogin" matButton="filled" type="button" class="dialog-btn-primary mt-4"
                    (click)="goToLogin()">Back To Login</button>
            </form>
        </div>
    </mat-dialog-content>
</div>